// ** Icon imports
import DashboardIcon from 'src/@core/components/icons/DashboardIcon'
import OrdersIcon from 'src/@core/components/icons/OrdersIcon'
import PaymentIcon from 'src/@core/components/icons/PaymentIcon'
import QMSIcon from 'src/@core/components/icons/QMSIcon'
import ServicesIcon from 'src/@core/components/icons/ServicesIcon'
import Dispute from 'src/@core/components/icons/Dispute'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import ChatIcon from 'src/@core/components/icons/chatIcon'
import NotificationIcon from 'src/@core/components/icons/NotificationIcon'
import SuscriptionPlanIcon from 'src/@core/components/icons/SuscriptionPlanIcon'
import AddressBookIcon from 'src/@core/components/icons/AddressBookIcon'
import TeamManagement from 'src/@core/components/icons/TeamManagement'
const navigation = t => {
  return [
    {
      id: 'dashboard',
      title: t('verticalmenuItems.Dashboard'),
      icon: DashboardIcon,
      path: '/dashboard',
      permission: null
    },
    {
      id: 'quotes_management',
      title: t('verticalmenuItems.Quotes Management'),
      icon: QMSIcon,
      path: '/qms',
      permission: 'customer_qms'
    },
    {
      id: 'orders',
      title: t('verticalmenuItems.Orders'),
      icon: OrdersIcon,
      path: '/orders',
      permission: 'customer_order'
    },
    {
      id: 'main_chat',
      title: t('verticalmenuItems.Chat'),
      icon: ChatIcon,
      path: '/chat',
      permission: 'customer_main_chat'
    },
    {
      id: 'payments',
      title: t('verticalmenuItems.Payments'),
      icon: PaymentIcon,
      path: '/payments',
      permission: 'customer_payments'
    },
    {
      id: 'subscriptions',
      title: 'Subscriptions',
      icon: SuscriptionPlanIcon,
      path: '/subscription-management',
      permission: null
    },
    {
      id: 'services',
      title: t('verticalmenuItems.Services'),
      icon: ServicesIcon,
      path: '/services',
      permission: 'customer_services'
    },
    {
      id: 'team_management',
      title: t('verticalmenuItems.Team Management'),
      icon: TeamManagement,
      path: '/team-management'
      // permission: 'customer_settings'
    },
    {
      id: 'dispute_center',
      title: t('verticalmenuItems.Dispute Center'),
      icon: Dispute,
      path: '/dispute-center',
      permission: 'customer_dispute_center'
    },
    {
      id: 'address_book',
      title: t('verticalmenuItems.Address Book'),
      icon: AddressBookIcon,
      path: '/address-book',
      permission: 'customer_address_book'
    }
    // {
    //   title: 'Subscriptions',
    //   icon: SuscriptionPlanIcon,
    //   path: '/freely-plan'
    // }
    // {
    //   title: 'Notifications',
    //   icon: NotificationIcon,
    //   path: '/notification'
    // }
    // {
    //   title: 'Payment Gateway',
    //   icon: AttachMoneyIcon,
    //   path: '/payment-gateway'
    // }
  ]
}

export default navigation
